export { START_LOCATION, useRoute } from 'vue-router'